import React from "react";

export const Gift1 = ({ className }) => {
  return (
    <svg
      className={`gift-1 ${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" opacity="0.5">
        <path
          className="path"
          d="M8 5.33335V14M8 5.33335C7.75885 4.33962 7.34363 3.49006 6.80849 2.89546C6.27335 2.30086 5.64312 1.98881 5 2.00002C4.55797 2.00002 4.13405 2.17561 3.82149 2.48817C3.50893 2.80073 3.33333 3.22466 3.33333 3.66668C3.33333 4.10871 3.50893 4.53263 3.82149 4.84519C4.13405 5.15776 4.55797 5.33335 5 5.33335M8 5.33335C8.24115 4.33962 8.65637 3.49006 9.19151 2.89546C9.72665 2.30086 10.3569 1.98881 11 2.00002C11.442 2.00002 11.866 2.17561 12.1785 2.48817C12.4911 2.80073 12.6667 3.22466 12.6667 3.66668C12.6667 4.10871 12.4911 4.53263 12.1785 4.84519C11.866 5.15776 11.442 5.33335 11 5.33335M12.6667 8.00002V12.6667C12.6667 13.0203 12.5262 13.3594 12.2761 13.6095C12.0261 13.8595 11.687 14 11.3333 14H4.66667C4.31304 14 3.97391 13.8595 3.72386 13.6095C3.47381 13.3594 3.33333 13.0203 3.33333 12.6667V8.00002M2.66667 5.33335H13.3333C13.7015 5.33335 14 5.63183 14 6.00002V7.33335C14 7.70154 13.7015 8.00002 13.3333 8.00002H2.66667C2.29848 8.00002 2 7.70154 2 7.33335V6.00002C2 5.63183 2.29848 5.33335 2.66667 5.33335Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
    </svg>
  );
};